module.exports = __webpack_public_path__ + "static/01.57c46936.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/gallery/01.png
// module id = 438
// module chunks = 35783957827783 172322841747965